import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminAbout from "@/pages/AdminAbout";
import AdminServices from "@/pages/AdminServices";
import AdminContact from "@/pages/AdminContact";
import AdminFAQ from "@/pages/AdminFAQ";
import AdminProjects from "@/pages/AdminProjects";
import AdminTestimonials from "@/pages/AdminTestimonials";
import { Toaster } from "@/components/ui/sonner";
import WhatsAppButton from "@/components/WhatsAppButton";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        {/* Ana sayfalar için Navbar göster, admin sayfalarında gösterme */}
        <Routes>
          <Route path="/admin/*" element={null} />
          <Route path="*" element={<Navbar />} />
        </Routes>
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kurumsal" element={<About />} />
          <Route path="/hizmetlerimiz" element={<Services />} />
          <Route path="/projelerimiz" element={<Projects />} />
          <Route path="/projelerimiz/:projectId" element={<ProjectDetail />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/sss" element={<FAQ />} />
          <Route path="/sikca-sorulan-sorular" element={<FAQ />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/about" element={<AdminAbout />} />
          <Route path="/admin/services" element={<AdminServices />} />
          <Route path="/admin/contact" element={<AdminContact />} />
          <Route path="/admin/faq" element={<AdminFAQ />} />
          <Route path="/admin/projects" element={<AdminProjects />} />
          <Route path="/admin/testimonials" element={<AdminTestimonials />} />
        </Routes>
        <WhatsAppButton />
        <ScrollToTop />
      </BrowserRouter>
      <CookieConsent />
      <Toaster />
    </div>
    </HelmetProvider>
  );
}

export default App;